import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';


import { fetchWrapper } from '_helpers';

// create slice
const name = 'mealPlans';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports
export const mealPlanActions = { ...slice.actions, ...extraActions };
export const mealPlansReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        currentWeekDate: new Date().toISOString().slice(0, 10),
        list: null,
        item: null
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/api/mealPlan`;

    return {
        // getAll: getAll(),
        getMealPlan: getMealPlan(),
        getMealPlanWeek: getMealPlanWeek(),
        setMeal: setMeal(),
        setCurrentWeek: setCurrentWeek()
    };

    // function getAll() {
    //     return createAsyncThunk(
    //         `${name}/getAll`,
    //         async () => await fetchWrapper.get(`${baseUrl}/getAll`)
    //     );
    // }

    function setCurrentWeek() {
        return createAsyncThunk(
            'setCurrentWeek',
            async function () {
            }
        )
    }

    function getMealPlan() {
        return createAsyncThunk(
            `${name}/getMealPlan`,
            async (selectedDate) => await fetchWrapper.get(`${baseUrl}/getMealPlan?date=${selectedDate}`)
        );
    }

    function getMealPlanWeek() {
        return createAsyncThunk(
            `${name}/getMealPlanWeek`,
            async (_, { getState }) => {
                const selectedDate = getState().mealPlans.currentWeekDate;
                return await fetchWrapper.get(`${baseUrl}/getMealPlanWeek?date=${selectedDate}`)
            }
        );
    }

    function setMeal() {
        return createAsyncThunk(
            `${name}/setMeal`,
            async (mealPlan) => await fetchWrapper.post(`${baseUrl}/setMeal`, mealPlan)
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        // getAll();
        getMealPlan();
        getMealPlanWeek();
        setMeal();
        setCurrentWeek();

        function setCurrentWeek() {
            var { fulfilled } = extraActions.setCurrentWeek;
            builder
                .addCase(fulfilled, (state, action) => { state.currentWeekDate = action.meta.arg; });
        }

        // function getAll() {
        //     var { pending, fulfilled, rejected } = extraActions.getAll;
        //     builder
        //         .addCase(pending, (state) => {
        //             state.list = { loading: true };
        //         })
        //         .addCase(fulfilled, (state, action) => {
        //             state.list = { value: action.payload };
        //         })
        //         .addCase(rejected, (state, action) => {
        //             state.list = { error: action.error };
        //         });
        // }

        function getMealPlan() {
            var { pending, fulfilled, rejected } = extraActions.getMealPlan;
            builder
                .addCase(pending, (state) => {
                    state.item = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.item = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.item = { error: action.error };
                });
        }

        function getMealPlanWeek() {
            var { pending, fulfilled, rejected } = extraActions.getMealPlanWeek;
            builder
                .addCase(pending, (state) => {
                    state.list = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.list = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.list = { error: action.error };
                });
        }

        function setMeal() {
            var { pending, fulfilled, rejected } = extraActions.setMeal;
            builder
                .addCase(pending, (state, action) => {
                    const mealPlan = state.list.value.find(x => x.date === action.meta.arg.date);
                    mealPlan.isSetting = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.list.value = state.list.value.filter(x => x.date !== action.meta.arg);
                })
                .addCase(rejected, (state, action) => {
                    const mealPlan = state.list.value.find(x => x.date === action.meta.arg.date);
                    mealPlan.isSetting = false;
                });
        }
    }
}